import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  profile: {},
  website: {},
  senderEmail: {},
  paginator: [],
  paymentProviders: [],
  withdraws: [],
  withdraw: {},
  orgPaymentProviders: [],
  loading: false,
  onSuccessUploadLogo: false,
  onSuccessUploadBanner: false,
  onSuccessUpdateProfile: false,
  onSuccessUpdatePassword: false,
  errorMsg: '',
  updatedState: '',
  errors: {},
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    setWebsite: (state, action) => {
      state.website = action.payload;
    },
    setUpdatedState: (state, action) => {
      state.updatedState = action.payload;
    },
    setSenderEmail: (state, action) => {
      state.senderEmail = action.payload;
    },
    setPaginator: (state, action) => {
      state.paginator = action.payload;
    },
    setPaymentProviders: (state, action) => {
      state.paymentProviders = action.payload;
    },
    setWithdrawHistories: (state, action) => {
      state.withdraws = action.payload;
    },
    setWithdraw: (state, action) => {
      state.withdraw = action.payload;
    },
    setOrgPaymentProviders: (state, action) => {
      state.orgPaymentProviders = action.payload;
    },
    setOnSuccessUploadLogo: (state, action) => {
      state.onSuccessUploadLogo = action.payload;
    },
    setOnSuccessUploadBanner: (state, action) => {
      state.onSuccessUploadBanner = action.payload;
    },
    setOnSuccessUpdateProfile: (state, action) => {
      state.onSuccessUpdateProfile = action.payload;
    },
    setOnSuccessUpdatePassword: (state, action) => {
      state.onSuccessUpdatePassword = action.payload;
    },
    getErrors: (state, action) => {
      state.errorMsg = action.payload.errorMsg;
      state.errors = action.payload.errors;
    },
    clearErrors: (state) => {
      state.errorMsg = '';
      state.errors = '';
    },
    loading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const {
  loading,
  setProfile,
  setWebsite,
  setSenderEmail,
  setUpdatedState,
  setPaymentProviders,
  setOrgPaymentProviders,
  setWithdrawHistories,
  setWithdraw,
  setPaginator,
  setOnSuccessUpdateProfile,
  setOnSuccessUploadLogo,
  setOnSuccessUploadBanner,
  setOnSuccessUpdatePassword,
  clearErrors,
  getErrors,
} = profileSlice.actions;
export default profileSlice.reducer;
